export default {
  SET_ORDER: 'SET_ORDER',
}
